import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { secondAxios } from "../../../../api/axios";

const initialForm = {
  paymentDate: "",
  amount: "",
  forWhom: "",
  approver: "",
  invoiceAmount: "",
};

export default function PaymentModal({ open, onClose, po }) {
  const [form, setForm] = React.useState(initialForm);
  const [payments, setPayments] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const fetchPayments = React.useCallback(async () => {
    if (!po?.id) return;
    setLoading(true);
    try {
      const { data } = await secondAxios.get("/payment", {
        params: { poId: po.id },
      });
      setPayments(Array.isArray(data) ? data : []);
    } catch (error) {
      console.error("Failed to load payments:", error);
      setPayments([]);
    } finally {
      setLoading(false);
    }
  }, [po]);

  React.useEffect(() => {
    if (open) {
      fetchPayments();
    }
  }, [open, fetchPayments]);

  const handleChange = (field) => (event) => {
    setForm((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleSave = async () => {
    if (!po?.id) return;
    await secondAxios.post("/payment", { ...form, poId: po.id });
    setForm(initialForm);
    fetchPayments();
  };

  const handleClose = () => {
    setForm(initialForm);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="md">
      <DialogTitle>Payments - {po?.po_name || po?.poNumber || ""}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 1 }}>
          <Stack direction="row" spacing={2}>
            <TextField
              label="Payment Date"
              type="date"
              value={form.paymentDate}
              onChange={handleChange("paymentDate")}
              InputLabelProps={{ shrink: true }}
              fullWidth
            />
            <TextField
              label="Amount"
              value={form.amount}
              onChange={handleChange("amount")}
              fullWidth
            />
          </Stack>
          <Stack direction="row" spacing={2}>
            <TextField
              label="For Whom"
              value={form.forWhom}
              onChange={handleChange("forWhom")}
              fullWidth
            />
            <TextField
              label="Approver"
              value={form.approver}
              onChange={handleChange("approver")}
              fullWidth
            />
            <TextField
              label="Invoice Amount"
              value={form.invoiceAmount}
              onChange={handleChange("invoiceAmount")}
              fullWidth
            />
          </Stack>
        </Stack>
        <Box sx={{ mt: 3 }}>
          <Typography variant="subtitle2">Existing Payments</Typography>
          {loading ? (
            <Typography variant="body2" sx={{ mt: 1 }}>
              Loading...
            </Typography>
          ) : payments.length ? (
            <Box sx={{ mt: 1, display: "grid", gap: 1 }}>
              {payments.map((payment) => (
                <Box
                  key={payment.id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr",
                    gap: 1,
                  }}
                >
                  <Typography variant="body2">
                    {payment.paymentDate || ""}
                  </Typography>
                  <Typography variant="body2">{payment.amount || ""}</Typography>
                  <Typography variant="body2">
                    {payment.forWhom || ""}
                  </Typography>
                  <Typography variant="body2">
                    {payment.approver || ""}
                  </Typography>
                  <Typography variant="body2">
                    {payment.invoiceAmount || ""}
                  </Typography>
                </Box>
              ))}
            </Box>
          ) : (
            <Typography variant="body2" sx={{ mt: 1 }}>
              No payments yet.
            </Typography>
          )}
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Close</Button>
        <Button variant="contained" onClick={handleSave}>
          Save Payment
        </Button>
      </DialogActions>
    </Dialog>
  );
}

